module.exports = __webpack_public_path__ + "img/idea-sparkles@2x.6a72c3d5.png";